import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import API_ENDPOINTS from '../../helperFunction/Constant';
import ApiHelper from '../../helperFunction/ApiHelper';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';

const AddCollectionCourses = () => {

    const { id } = useParams()

    const toast = useRef(null)

    const [searchInput, setSearchInput] = useState('')

    const [visible, setVisible] = useState(false)

    const [acitveCourses, setActiveCourses] = useState([])

    const [collectionCoursesData, setCollectionCoursesData] = useState([])

    const [selected, setSelected] = useState([]);

    const [categoryData, setCategoryData] = useState([])
        
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    
    const [orderIsChanged, setOrderIsChanged] = useState(false);

    useEffect(() => {
        getCollectionCourses()
        getActivesCourses()
        getActivesCategories()
    }, [])

    const getActivesCourses = () => {
        ApiHelper.get(`${API_ENDPOINTS.COURSES}?active=true`).then((res) => {
            if (res.status === 200) {
                setActiveCourses(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const getActivesCategories = () => {
        ApiHelper.get(`${API_ENDPOINTS.CATEGORY}?active=true`).then((res) => {
            console.log('res: ', res);
            if (res.status === 200) {
                setCategoryData(res?.data?.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const getCollectionCourses = () => {
        ApiHelper.get(`${API_ENDPOINTS.COLLECTION_COURSES}/${id}`).then((res) => {
            if (res.status === 200) {
                setCollectionCoursesData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const add = () => {
        const obj = {
            collectionId: id,
            courseId: selected.map(item => item.courseId).join(','),
            order: selected.map(item => item.order).join(',')
        };
        ApiHelper.post(`${API_ENDPOINTS.COLLECTION_COURSES}/${id}`, obj).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getCollectionCourses()
                setSelected([])
                setVisible(false)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = (collectionCourseId) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteCollectionCourse(collectionCourseId),
        });
    };

    const deleteCollectionCourse = (collectionCourseId) => {
        ApiHelper.delete(`${API_ENDPOINTS.COLLECTION_COURSES}/${collectionCourseId}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getCollectionCourses();
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    const handleListSelect = (courseId) => {
        const existingIndex = selected.findIndex((itemData) => itemData.courseId === courseId);
        if (existingIndex !== -1) {
            setSelected(selected.filter((itemData) => itemData.courseId !== courseId));
        } else {
            setSelected([...selected, { courseId, order: selected.length + 1 }]);
        }
    };

    const filteredCourses = acitveCourses.filter((item) =>
        item.courseName?.toString().toLowerCase().includes(searchInput.toLowerCase()) &&
        (!selectedCategoryId || Number(item.categoryId) === Number(selectedCategoryId)) &&
        !collectionCoursesData.some((selected) => selected.courseId === item.courseId),
    );

    const headerElement = (
        <div className="d-flex justify-content-between align-items-center">
            <div>
                <div>Select Courses</div>
                <div className="text-muted mt-0 fw-normal fs-6">{`${selected.length} courses selected`}</div>
            </div>
        </div>
    );
    
    const footerContent = (
        <div className='mt-3'>
            <button className='btn btn-primary' onClick={() => add()}>Save</button>
        </div>
    );

    const handleDragStart = (e, index) => {
        e.dataTransfer.setData("dragIndex", index);
    };
    
    const handleDrop = (e, dropIndex) => {
        setOrderIsChanged(true)
        const dragIndex = Number(e.dataTransfer.getData("dragIndex"));
        const items = [...collectionCoursesData];
        const [movedItem] = items.splice(dragIndex, 1);
        items.splice(dropIndex, 0, movedItem);
        setCollectionCoursesData(items);
    };

    const saveOrder = () => {
        const payload = collectionCoursesData.map((item, index) => ({
            id: item.collectionCourseId,
            order: index + 1
        }));
        ApiHelper.put(`${API_ENDPOINTS.COLLECTION_COURSES}/save-order`, payload).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getCollectionCourses();
                setOrderIsChanged(false)
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    }


    return (
        <>
            <Toast ref={toast} />
            <div className='mt-1'>
                <div className='d-flex' style={{ justifyContent: 'space-between' }}>
                    <div>
                        <h6><b>Collections Courses</b></h6>
                        <p>Select courses that you want to add in Collection</p>
                    </div>
                    <div>
                        <button className='btn btn-primary mt-2' onClick={() => setVisible(true)}>Browse</button>
                    </div>
                </div>
                {collectionCoursesData.length > 0 ? (
                    collectionCoursesData.map((item, index) => (
                        <li className="list-group-item mb-2" draggable={true} onDragStart={(e) => handleDragStart(e, index, item)} onDragOver={(e) => e.preventDefault()} onDrop={(e) => handleDrop(e, index)} style={{ cursor: 'pointer', border: "1px solid #dee2e6", borderRadius: "8px", }} >
                            <div className="d-flex align-items-center" style={{ justifyContent: 'space-between' }}>
                                <div className="d-flex align-items-center">
                                    <div>
                                        <i className="bi bi-list me-2" style={{ cursor: "grab", fontSize: "1.5rem" }} ></i>
                                    </div>
                                    <div className="me-3">
                                        <img className="me-3" src={`${process.env.REACT_APP_BASE_URL}/${item?.courseImage}`} onError={(e) => { e.target.src = "/img/placeholder-image.jpg" }} alt="" style={{ width: '100px', height: '100px', borderRadius: '10px', objectFit: 'cover' }} />
                                    </div>
                                    <div>
                                        <label> <b> {item?.courseName} </b> </label>
                                    </div>
                                </div>
                                <div>
                                    <button className='btn btn-danger' onClick={() => confirmDeleteDailog(item.collectionCourseId)} >&times;</button>
                                </div>
                            </div>
                        </li>
                    ))
                ) : (
                    <div className='mt-3' style={{ border: '2px dashed #dddddd', borderRadius: '5px' }}>
                        <div className='m-5'>
                            <h4><b>No Courses Selected</b></h4>
                            <p>Click "Browse" to add courses</p>
                        </div>
                    </div>
                )}
                {orderIsChanged && (
                    <div className='mt-3'>
                        <button className='btn btn-primary' onClick={() => saveOrder()}>Save Order</button>
                    </div>
                )}
            </div>
            <Dialog header={headerElement} visible={visible} footer={footerContent} style={{ width: '50vw' }} onHide={() => { if (!visible) return; { setVisible(false); setSelected([]); } }} >
                <div className='d-flex'>
                    <div className='col-md-8 me-2'>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-search"></InputIcon>
                            <InputText className="w-100" value={searchInput} onChange={(e) => setSearchInput(e.target.value)} placeholder="Search" />
                        </IconField>
                    </div>
                    <div className='col-md-4'>
                        <select id="mySelect" name="categoryId" value={selectedCategoryId} onChange={(e) => setSelectedCategoryId(e.target.value)} className="form-select" >
                            <option value="">Select Category</option>
                            {categoryData.map((item) => (
                                <option value={item.categoryId}>{item.categoryName}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="mt-3">
                    <ul className="list-group">
                        {filteredCourses.map((item, index) => {
                            const isSelected = selected.findIndex((itemData) => itemData.courseId === item.courseId) !== -1;;
                            return (
                                <li className="list-group-item mb-2" key={index} onClick={() => handleListSelect(item.courseId)} style={{ cursor: 'pointer', backgroundColor: isSelected ? '#e7f1ff' : '', border: "1px solid #dee2e6", borderRadius: "8px", }} >
                                    <div className="d-flex align-items-center">
                                        <div className="me-3">
                                            <Checkbox checked={isSelected} onChange={() => handleListSelect(item.courseId)} />
                                        </div>
                                        <img className="me-3" src={`${process.env.REACT_APP_BASE_URL}/${item.courseImage}`} alt="" style={{ width: '100px', height: '100px', borderRadius: '10px', objectFit: 'cover' }}
                                            onError={(e) => {
                                                e.target.src = "/img/placeholder-image.jpg"
                                            }}
                                        />
                                        <div>
                                            <label> <b> {item.courseName} </b> </label>
                                            <p className="mb-0"> 
                                                <b className='me-2' style={{fontSize: '20px', color: 'black'}}>₹{item.courseMrp}</b> 
                                                <strike>₹{item.coursePrice}</strike> 
                                                <span className='badge bg-danger mx-2'>{item.courseMrp && item.coursePrice ? Math.round(((item.courseMrp - item.coursePrice) / item.courseMrp) * 100) : 0}%</span> 
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            )
                        }
                        )}
                    </ul>
                </div>
                <div className='mt-3'>
                    <button className='btn btn-primary' onClick={() => add()}>Save</button>
                </div>
            </Dialog>
        </>
    )
}

export default AddCollectionCourses
